import { useEffect, useState } from "react"
import MainContentWrapper from "../../Components/MainContentWrapper"
import { getCrmleads } from "../../apis/BhuMeetTeams/Crm/leads"
import TableView from "../../ReusableComponents/TableView/TableView"
import { Button } from "../../Components/Helper"
import { CreateLeads } from "./createLeads"
import { useNavigate } from "react-router"
import { getCrmleadsLog } from "../../apis/BhuMeetTeams/Crm/leadsCallHistory"
import dateFormat from "dateformat";
import DurationFilters from "../../features/Revenue/SubComponents/DurationFilters"
import IssueDashboardFilter from "../Operations/RequestIssue/issueDashboardFilter"


export const AllLeadsCallHistory = () => {
    const navigate = useNavigate()
    const [allLeads, setAllLeads] = useState([])
    const [filter, setFilters] = useState(()=>{
        const getFilters =  localStorage.getItem("CRMLeadsLogFilter");
        return getFilters ? JSON.parse(getFilters) : {
            fromDate: null,
            toDate: null,
            pageSize: 15,
            count: 0,
            currentPage: 1,
            interval:"all"
        }
    })
    const [openform, setOpenForms] = useState(false)
    const [loading, setloading] = useState(false)
    const [openFilter, setOpenFilter] = useState(false)
    const [formattedDate, setFormattedDate] = useState()

    const durationOptions = [
        { id: 6, placeholder: "All", interval: "all" },
        { id: 1, placeholder: "Today", interval: "day" },
        { id: 2, placeholder: "This Week", interval: "week" },
        { id: 3, placeholder: "This Month", interval: "month" },
        { id: 4, placeholder: "This Year", interval: "year" },
        {
            id: 5,
            placeholder: "Custom",
            interval: "custom",
            cb: () => {
                console.log("Custom")
                setOpenFilter(true);
            },
        },

    ];

    const getFormattedFromAndToDate = (interval) => {
        let formattedDate = ''
        switch (interval) {
            case 'day':
                formattedDate = `Date: ${dateFormat(
                    filter.fromDate,
                    "dd/mm/yyyy "
                )}`
                break;
            case "week":
                const fromDateMinusOneDay = new Date(filter.fromDate);
                fromDateMinusOneDay.setDate(fromDateMinusOneDay.getDate() - 1);
                formattedDate = `Date: ${dateFormat(fromDateMinusOneDay, "dd/mm/yyyy ")} 
                    to ${dateFormat(filter.toDate, "dd/mm/yyyy ")}`;
            case "month":
            case "year":
                formattedDate = `Date: ${dateFormat(filter.fromDate, "dd/mm/yyyy ")} 
                    to ${dateFormat(filter.toDate, "dd/mm/yyyy ")}`
                break;
            case "custom":
                formattedDate = `Date: ${dateFormat(filter.fromDate, "dd/mm/yyyy hh:MM TT ")} 
                    to ${dateFormat(filter.toDate, "dd/mm/yyyy hh:MM TT")}`
                break;
            default:
                formattedDate = ''
        }
        setFormattedDate(formattedDate);

    }

    useEffect(() => {
        getAllLeads()
        localStorage.setItem("CRMLeadsLogFilter",JSON.stringify(filter))
    }, [filter.fromDate, filter.toDate, filter.currentPage])


    const getAllLeads = async () => {
        setloading(true)
        const leads = await getCrmleadsLog(filter)
        setloading(false)
        setAllLeads(leads.leads)
        setFilters((prev)=>({...prev,count:leads.count}))
        getFormattedFromAndToDate(filter.interval)
    }

    return <MainContentWrapper header={"Leads History"} >
        {openform && <CreateLeads open={openform} onClose={() => { setOpenForms(false); getAllLeads() }} />}

        <div style={{ display: "flex", marginBottom: "5px" }}>
            <div>
                <DurationFilters handleFilterChanged={(e) => {
                    // console.log(e)
                    setloading(true)
                    setFilters((prev) => ({ ...prev, fromDate: e.fromDate, toDate: e.toDate, interval: e.interval,currentPage:1 }))

                }}
                    interval={filter.interval}
                    isAdmin={true}
                    options={durationOptions} />
            </div>
            <div style={{ marginLeft: "10px", marginTop: "4px" }} className="date_section">
                <span>{formattedDate}</span>
            </div>

        </div>


        {openFilter &&
            <IssueDashboardFilter open={openFilter} onFilterChange={(e) => {
                console.log(e)

                setFilters((prev) => ({ ...prev, fromDate: e.fromDate, toDate: e.toDate, interval: !e.fromDate || !e.toDate ? e.interval || filter.interval : "custom",currentPage:1 }))
                setOpenFilter(false)
            }}
                filter={filter}
                onClose={(e) => {
                    console.log(e)
                    if (!filter.fromDate || !filter.toDate) {
                        console.log("ALL")
                        setFilters((prev) => ({ ...prev, interval: "all" }))
                        setFormattedDate('')
                    }

                    setOpenFilter(false)
                }} />
        }

        <TableView
            showSrNo={true}
            onStateChange={async (changedState) => {
                const { pageNumber } = changedState;
                // console.log(changedState);
                // setCurrentPage(() => pageNumber);
                  setFilters({ ...filter, currentPage: pageNumber })

            }}
            onClickRow={(row) => {

                console.log(row)
                navigate('/crm/leads/detail', { state: row });

            }}
            isLoading={loading}
            loaderHeight={"500px"}
            columns={[
                { Header: "Call By", accessor: "call_by", width: "9%" },
                { Header: "Call To", accessor: "name", width: "10%" },
                { Header: "Request Note", accessor: "note", width: "20%" },
                { Header: "Call Duration", accessor: "duration", width: "9%" },
                { Header: "Status", accessor: "status", width: "9%" },

                { Header: "Date", accessor: "created", isDate: true, width: "10%" },
            ]}
            data={allLeads}
            tableContainerHeight={"90%"}
            pageNumber={filter.currentPage ?? 1}
            pageSize={15}
            count={Number(filter?.count) || 0}



        // activities={{ onClickCall: (coupon) => {console.log(coupon)}}}
        />



    </MainContentWrapper>

}